import { useEffect, useState } from "react";

export const useMapHeight = () => {
  const [mapHeight, setMapHeight] = useState<string>("100%");

  useEffect(() => {
    const calculateMapHeight = () => {
      const navbarHeight = 64;
      const paddingHeight = 120;
      const windowHeight = window.innerHeight;
      const calculatedHeight = windowHeight - navbarHeight - paddingHeight;
      setMapHeight(`${calculatedHeight}px`);
    };

    calculateMapHeight();
    window.addEventListener("resize", calculateMapHeight);
    return () => window.removeEventListener("resize", calculateMapHeight);
  }, [setMapHeight]);
  return { mapHeight, setMapHeight };
};
